import omit from 'lodash-es/omit'

import { getPropsFromNode, nodeMatches } from '../utils'
import LightboxEntry from '../../components/molecule/Lightbox'
import { h } from '../parser/utils'

import { processHref } from './links'

export const NAME = 'lightbox'

export const COMPONENTS = {
  LightboxEntry,
}

export function matches(node) {
  return nodeMatches(node, '.lightview, [rel="lightbox"], [rel^="gallery"]')
}

export async function transform (node, next, ctx) {
  const children = await next(node.childNodes, ctx)

  const props = getPropsFromNode(node)

  const caption = props.title && h('p', {}, props.title)
  const group = props.rel ? (props.rel || '').replace(/gallery\[(.*)]/, '$1') : undefined

  return h(
    LightboxEntry,
    {
      ...omit(props, ['href', 'rel']),
      src: processHref(props.href),
      caption,
      group,
    },
    ...children,
  )
}
